import { Check } from "lucide-react";

const WORKSHOP_IMG =
  "https://static.prod-images.emergentagent.com/jobs/4f3190bd-1b22-40d9-b386-e9731f443b12/images/94167a06f34e57a4e02f8ac29dd7a5931f6d87b969a799f08baad1da5de20f8e.png";

const POINTS = [
  "Capannone operativo da 500 mq con deposito attrezzature e magazzino materiali",
  "Area esterna da 2000 mq dedicata a logistica cantieri e attrezzature",
  "Officina di carpenteria metallica interna con fabbro dedicato",
  "Ponteggi proprietari e ascensore da cantiere fino a 30 metri — usati esclusivamente sui nostri cantieri (no nolo)",
  "Squadra strutturata: muratori, decoratori, fabbro, geometra di cantiere",
  "Manodopera 100% interna — nessun subappalto sulle lavorazioni chiave",
];

export default function About() {
  return (
    <section
      id="azienda"
      data-testid="about-section"
      className="relative bg-[#0A1120] py-28 md:py-40 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 items-start">
          {/* Left column - image bento */}
          <div className="lg:col-span-6 grid grid-cols-6 grid-rows-6 gap-3 md:gap-4 h-[480px] md:h-[640px]">
            <div className="col-span-4 row-span-6 relative overflow-hidden bg-[#111C30]">
              <img
                src={WORKSHOP_IMG}
                alt="Officina carpenteria metallica Dea srl"
                className="w-full h-full object-cover grayscale-[20%]"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/90 to-transparent">
                <div className="text-xs tracking-[0.3em] uppercase text-[#FF5A1F] font-bold mb-2">
                  Sede operativa
                </div>
                <div className="text-white font-bold text-xl">
                  Carpenteria interna
                </div>
              </div>
            </div>

            <div className="col-span-2 row-span-3 bg-[#FF5A1F] p-5 md:p-6 flex flex-col justify-between">
              <div className="text-xs tracking-[0.3em] uppercase text-white/80 font-bold">
                Capannone
              </div>
              <div>
                <div className="text-4xl md:text-5xl font-bold text-white tabular tracking-tight">
                  500
                </div>
                <div className="text-xs uppercase tracking-wider text-white/90 mt-1">
                  mq coperti
                </div>
              </div>
            </div>

            <div className="col-span-2 row-span-3 bg-[#111C30] border border-[#1E293B] p-5 md:p-6 flex flex-col justify-between">
              <div className="text-xs tracking-[0.3em] uppercase text-slate-500 font-bold">
                Area esterna
              </div>
              <div>
                <div className="text-4xl md:text-5xl font-bold text-white tabular tracking-tight">
                  2000
                </div>
                <div className="text-xs uppercase tracking-wider text-slate-400 mt-1">
                  mq logistica
                </div>
              </div>
            </div>
          </div>

          {/* Right column - text */}
          <div className="lg:col-span-6 lg:pl-6">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-px bg-[#FF5A1F]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#FF5A1F] font-bold">
                L'Azienda
              </span>
            </div>

            <h2 className="headline text-white text-4xl md:text-6xl">
              Un'impresa{" "}
              <span className="font-display italic font-medium text-slate-300">
                strutturata
              </span>{" "}
              dalle fondamenta.
            </h2>

            <p className="mt-8 text-slate-400 text-base md:text-lg leading-relaxed">
              Dea srl nasce dall'esperienza diretta in cantiere. Abbiamo
              investito sulla sede, sui mezzi e sulla squadra:{" "}
              <span className="text-white">
                tutto ciò che serve per consegnare opere complete senza dipendere
                da terzi.
              </span>
            </p>

            <ul className="mt-10 space-y-4">
              {POINTS.map((p, i) => (
                <li
                  key={i}
                  data-testid={`about-point-${i}`}
                  className="flex gap-4 items-start border-b border-slate-800 pb-4"
                >
                  <span className="w-6 h-6 bg-[#FF5A1F] flex-shrink-0 flex items-center justify-center mt-0.5">
                    <Check size={14} strokeWidth={3} className="text-white" />
                  </span>
                  <span className="text-slate-300 leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-col sm:flex-row gap-8 pt-8 border-t border-slate-700">
              <div>
                <div className="font-mono text-xs tracking-[0.25em] text-slate-500 mb-2">
                  Fondazione
                </div>
                <div className="text-2xl font-bold text-white">2022</div>
              </div>
              <div>
                <div className="font-mono text-xs tracking-[0.25em] text-slate-500 mb-2">
                  Area operativa
                </div>
                <div className="text-2xl font-bold text-white">
                  Pavia · Milano
                </div>
              </div>
              <div>
                <div className="font-mono text-xs tracking-[0.25em] text-slate-500 mb-2">
                  Forma giuridica
                </div>
                <div className="text-2xl font-bold text-white">S.r.l.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
